import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const SortingArrowsIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33203 6.66602H11.9987"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33203 9.33398H10.6654"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33203 12H9.33203"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33203 4H13.9987"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 12.5417C4.40452 12.8367 3.70679 14 3.33333 14M3.33333 14C2.95988 14 2.26215 12.8367 2 12.5417M3.33333 14V10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3.45833C2.26215 3.16334 2.95988 2 3.33333 2M3.33333 2C3.70679 2 4.40452 3.16334 4.66667 3.45833M3.33333 2V6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
